import { render } from "./AddOrUpdateCustomerGroupPricingForZone.html?vue&type=template&id=c042a7a4&scoped=true"
import script from "./AddOrUpdateCustomerGroupPricingForZone.js?vue&type=script&lang=js"
export * from "./AddOrUpdateCustomerGroupPricingForZone.js?vue&type=script&lang=js"

import "./AddOrUpdateCustomerGroupPricingForZone.css?vue&type=style&index=0&id=c042a7a4&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c042a7a4"]])

export default __exports__